<template>
  <!--Render web past starts-->
  <div v-if="runnerName && !isMobile" class="runnerDetails">
    <RunnerStartsColumns v-if="typeof featureToggle[bookie].pastStarts === 'undefined'" :runnerForm="runnerForm" :runnerTabNo="runnerTabNo" :runnerName="runnerName" :race="race"/>
  </div>
  <!--Render mobile past starts-->
  <div v-else-if="runnerName && isMobile" class="runnerDetails">
    <RunnerStartsColMobile v-if="typeof featureToggle[bookie].pastStarts === 'undefined'" :runnerForm="runnerForm" :runnerTabNo="runnerTabNo" :runnerName="runnerName" :race="race"/>
  </div>
</template>

<script>
import RunnerStartsColumns from '@/components/RunnerStartsColumns'
import RunnerStartsColMobile from '@/components/RunnerStartsColMobile'
import { featureToggle } from '../common/config'
import { mapGetters, mapState } from 'vuex'
export default {
  name: 'RunnerDetails',
  props: {
    runnerName: Object,
    race: Object,
    runnerForm: Array,
    runnerTabNo: Number
  },
  components: { RunnerStartsColumns, RunnerStartsColMobile },
  data () {
    return {
      token: this.$route.params.id,
      featureToggle
    }
  },
  computed: {
    ...mapState(['bookie']),
    ...mapGetters(['isMobile'])
  }
}
</script>

<style scoped>
.runnerDetails {
  background-color: white;
  color: black;
  overflow:hidden;
}
</style>
